import axios from 'axios'; //importar axios para fazer requisições http

//URL BASE: https://api.themoviedb.org/3/
//URL: https://api.themoviedb.org/3/movie/now_playing?api_key=51fbcb314004a461c9dae6099bbc6134&language=pt-br

//1) criar a instância do axios
//2) definir a baseURL e os parâmetros padrão

const api = axios.create({
  baseURL: 'https://api.themoviedb.org/3/',
});

export default api;